import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_FIELD_TAPPED_SCHEMA = Object.freeze({
  FIELD_IDENTIFIER: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_FIELD_TAPPED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_FIELD_TAPPED_SCHEMA);

export class FieldTappedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.field_tapped;
  }

  get properties() {
    return this.toJS();
  }
}
